(() => {
  if (window.__nnHomeCardQuickActionsLoaded) return;
  window.__nnHomeCardQuickActionsLoaded = true;

  let scheduled = false;

  const icon = `
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M5.5 8.5h13l-1 11h-11l-1-11Z"></path>
      <path d="M9 9V6.75a3 3 0 0 1 6 0V9"></path>
      <path d="M12 12v4M10 14h4"></path>
    </svg>
  `;

  const sourceButtonFor = (quickAdd) => {
    const mode = quickAdd.dataset.quickAddButton;
    return mode === 'choose'
      ? quickAdd.querySelector('.quick-add__button--choose')
      : quickAdd.querySelector('.quick-add__button--add');
  };

  const enhanceCard = (card) => {
    const content = card.querySelector('.product-card__content');
    const discover = content?.querySelector('.nn-card-explore');
    const quickAdd = card.querySelector('quick-add-component');

    if (!content || !discover || !quickAdd) return;

    let actions = content.querySelector(':scope > .nn-card-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'nn-card-actions';
      content.appendChild(actions);
    }

    let trigger = actions.querySelector('.nn-card-quick-action');
    if (!trigger) {
      const requiresChoice = quickAdd.dataset.quickAddButton === 'choose';
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'nn-card-quick-action';
      trigger.innerHTML = `${icon}<span class="nn-card-quick-action__label">${requiresChoice ? 'Choose' : 'Add'}</span>`;
      trigger.setAttribute('aria-label', `Quick add ${quickAdd.dataset.productTitle || 'product'} to cart`);
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const source = sourceButtonFor(quickAdd);
        if (!source || source.disabled) return;

        source.click();
        trigger.classList.add('is-activated');
        const label = trigger.querySelector('.nn-card-quick-action__label');
        if (label && !requiresChoice) label.textContent = 'Added ✓';
        window.setTimeout(() => {
          trigger.classList.remove('is-activated');
          if (label && !requiresChoice) label.textContent = 'Add';
        }, 1400);
      });
    }

    quickAdd.classList.add('nn-card-quick-add-source');
    actions.append(discover, trigger);
  };

  const enhance = () => {
    scheduled = false;
    if (window.location.pathname !== '/') return;
    document.querySelectorAll('product-card.nn-backpack-card').forEach(enhanceCard);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  setTimeout(schedule, 700);
  setTimeout(schedule, 1600);
  document.addEventListener('shopify:section:load', schedule);

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
})();
